import { render, staticRenderFns } from "./insurance-card.vue?vue&type=template&id=be9325da&scoped=true"
import script from "./insurance-card.vue?vue&type=script&lang=ts&setup=true"
export * from "./insurance-card.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9325da",
  null
  
)

export default component.exports